import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7652b38b")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Go to the ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" of the Order Management System (OMS).")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "Select your Shop and edit access scope, setting it to \"Shopify shop read and write access\".", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Go to the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://job-manager.hotwax.io",
    target: "_blank"
  }, "Job manager")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, "Open the \"Initial load\" page", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, "Select the \"Import Products in Bulk\" function, and run the import.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, "Open the \"Miscellaneous Jobs\" page", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "Select the \"Process bulk imported files\" function and run it.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, "Return to the \"Initial Load\" page.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, "Select the \"Import Orders in Bulk\" function", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", null, "Input the last Shopify order ID to import orders from and run the import.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, "Open the \"Miscellaneous Jobs\" page", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, "Select the \"Process bulk imported files\" function and run it.", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Go to the Order Management System (OMS) to view your ")
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("To know more: Watch this "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/watch?v=UpbwX8rYnVk",
    target: "_blank"
  }, "demo video"),
  /*#__PURE__*/_createTextVNode(" of how to use HotWax and Shopify integration through the Job Manager.")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("If you have any questions or need further assistance, please contact us at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@hotwax.co" }, "support@hotwax.co")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("header", null, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("Welcome to Hotwax Commerce Order Management for Shopify")), 1)
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Enter connection information to make sure your Shopify store can talk to your HotWax Commerce instance.")), 1),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("HotWax Commerce URL")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.connectConfig.instanceAddress,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.connectConfig.instanceAddress = $event)),
                          placeholder: "your-oms.hotwax.io",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfigUpdated = false))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Shared API Token")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "password",
                          modelValue: _ctx.connectConfig.instanceToken,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.connectConfig.instanceToken = $event)),
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isConfigUpdated = false))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      disabled: !_ctx.connectConfig.instanceAddress || !_ctx.connectConfig.instanceToken,
                      expand: "block",
                      onClick: _ctx.updateConnectConfig
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.saveOutline
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("SAVE")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.isConfigUpdated && _ctx.connectConfig.instanceAddress && _ctx.connectConfig.instanceToken)
              ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Your instance is ready to use.")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.connectConfig.instanceAddress && _ctx.connectConfig.instanceToken)
              ? (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Manage your sync with Shopify")), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Complete the following steps to see products and orders of this Shopify store in HotWax Commerce app.")), 1),
                        _createElementVNode("ol", null, [
                          _createElementVNode("li", null, [
                            _hoisted_2,
                            _createElementVNode("a", {
                              href: _ctx.connectConfig.instanceAddress.startsWith('https') ? _ctx.connectConfig.instanceAddress : 'https://' + _ctx.connectConfig.instanceAddress + '/commerce/control/FindShopifyShop' ,
                              target: "_blank"
                            }, "Shopify Shop page", 8, _hoisted_3),
                            _hoisted_4
                          ]),
                          _hoisted_5,
                          _hoisted_6,
                          _hoisted_7,
                          _hoisted_8,
                          _hoisted_9,
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15,
                          _createElementVNode("li", null, [
                            _hoisted_16,
                            _createElementVNode("a", {
                              href: _ctx.connectConfig.instanceAddress.startsWith('https') ? _ctx.connectConfig.instanceAddress : 'https://' + _ctx.connectConfig.instanceAddress + '/commerce/control/FindProduct',
                              target: "_blank"
                            }, "products", 8, _hoisted_17),
                            _hoisted_18,
                            _createElementVNode("a", {
                              href: _ctx.connectConfig.instanceAddress.startsWith('https') ? _ctx.connectConfig.instanceAddress : 'https://' + _ctx.connectConfig.instanceAddress + '/commerce/control/FindOrder',
                              target: "_blank"
                            }, "orders", 8, _hoisted_19),
                            _hoisted_20
                          ])
                        ]),
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}